import { Injectable, NgZone }   from '@angular/core';
import { InteractivityChecker } from "@angular/cdk/a11y";
import {UP_ARROW, DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW, TAB, HOME, END} from '@angular/cdk/keycodes';

@Injectable({
    providedIn: 'root'
})
export class AccessibilityService {

    constructor(private ngZone: NgZone, private interactivityChecker: InteractivityChecker) {}

    setFocusOnTab(selector, timeout = 0, cb?) {
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                const element =  <HTMLElement>document.querySelector(selector);
                if (element) {
                    if(!this.interactivityChecker.isFocusable(element)){
                        element.setAttribute('tabindex', '-1');
                    }
                    element.focus();
                    if (cb) {
                        cb();
                    }
                }
            }, timeout);
        });
    }

	setFocusOnTabByElement(el, timeout = 0, cb?) {
		this.ngZone.runOutsideAngular(() => {
			setTimeout(() => {
				const element =  <HTMLElement>el;
				if (element) {
					element.focus();
					if (cb) {
						cb();
					}
				}
			}, timeout);
		});
	}

    setFocusOnItemInList(listSelector, itemIndex, timeout = 0, cb?) {
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                const element =  <HTMLElement>document.querySelectorAll(listSelector)[itemIndex];
                console.log('element: ', element);
                if (element) {
                    if(!this.interactivityChecker.isFocusable(element)){
                        element.setAttribute('tabindex', '-1');
                    }
                    element.focus();
                    if (cb) {
                        cb();
                    }
                }
            }, timeout);
        });
    }



    addArrowNavigation(wrapSelector, itemSelector, positionSelector, focusedItem, isHorizontal = false, isVertical = false) {
        return (event, index, first, last, tabFocusSelector = ''):void => {
            let selector = '';
            //next
            if(event.keyCode == LEFT_ARROW && isHorizontal || event.keyCode == DOWN_ARROW && isVertical) {
                selector = last ? `${wrapSelector} ${itemSelector}:first-child ${focusedItem}` : `${wrapSelector} ${itemSelector}${positionSelector}${index + 1} ${focusedItem}`;
            }
            //prev
            if(event.keyCode == RIGHT_ARROW  && isHorizontal || event.keyCode == UP_ARROW && isVertical) {
                selector = first ? `${wrapSelector} ${itemSelector}:last-child ${focusedItem}` : `${wrapSelector} ${itemSelector}${positionSelector}${index -1} ${focusedItem}`;
            }

            if(event.keyCode == HOME ) {
                selector = `${wrapSelector} ${itemSelector}:first-child ${focusedItem}`;
            }

            if(event.keyCode == END ) {
                selector = `${wrapSelector} ${itemSelector}:last-child ${focusedItem}`;
            }

            if(selector) {
                event.stopPropagation();
                event.preventDefault();
                this.setFocusOnTab(selector);
            }
            if(tabFocusSelector && event.keyCode == TAB) {
                event.stopPropagation();
                event.preventDefault();
                this.setFocusOnTab(tabFocusSelector);
            }
        }
    }

}
